export const MSG_UPDATE_OK = 'Información actualizada correctamente';
export const MSG_UPDATE_SCHEDULE_OK = 'Horarios actualizados correctamente';
export const MSG_UPDATE_ERROR = 'Error al actualizar la información';
export const MSG_GET_ERROR = 'Error al consultar la información del comercio';
export const MSG_GET_BILLING_ERROR = 'Error al consultar la información de pago';
export const MSG_GET_GIGSTACK_ERROR = 'Error al consultar la información de sus facturas';
